import styled from 'styled-components';
import { Box, IconButton } from '@mui/material';

export const FieldWrapper = styled(Box)`
  display: flex;
  align-items: center;
  width: 100%;
  gap: 8px; /* Equivalente a gap: 1 en MUI */
`;

export const InputContainer = styled(Box)`
  flex-grow: 1;
`;

export const StyledIconButton = styled(IconButton)`
  margin-bottom: 16px; /* Equivalente a mb: 2 */
`;
